import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from "../utils/cn.js";
import { Icons } from "../utils/icons.js";
/**
 * Horizontally-directional glyphs: their arrowhead points along the inline
 * axis, so they must mirror under `dir="rtl"`. Vertical chevrons/arrows
 * (down/up) and non-directional icons are NOT listed — they read the same in
 * both directions. Flipping is applied automatically via `rtl:-scale-x-100`
 * so every call site mirrors without per-usage classes.
 */
const HORIZONTAL_DIRECTIONAL = new Set([
    "arrowRight",
    "chevronLeft",
    "chevronRight",
]);
export function Icon({ name, size = 18, className, ...aria }) {
    const C = Icons[name];
    return (_jsx(C, { "data-slot": "icon", width: size, height: size, strokeWidth: 1.5, className: cn("inline-block shrink-0", HORIZONTAL_DIRECTIONAL.has(name) && "rtl:-scale-x-100", className), ...aria }));
}
